import { _sharedActionsConstantsToc } from "./actions";

export const _sharedStateToc = {
  items: {},
};

export const _sharedReducerToc = (state, action) => {
  switch (action.type) {
    case _sharedActionsConstantsToc.SET_ITEM:
      if (state.items[action.data.bookIdOrigin]) {
        return state;
      }

      return {
        ...state,
        items: {
          ...state.items,
          [action.data.bookIdOrigin]: action.data.toc,
        }
      };
    default:
      return state;
  }
};
